import { Trans } from "@lingui/react";
import { i18n } from "@lingui/core";
import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { pathOr } from 'ramda';
import { Button, Input, Textarea, Typography, TagsEditor, LoadingWrapper } from '@prezi/common-components';
import { selectDocument } from '../../../store';
import { actions } from '../../../store/actions/actions';
import * as Atoms from '../../atoms';
import * as Molecules from '../../molecules';
const ButtonSection = styled(Atoms.Dumb.Section).withConfig({
  displayName: "Page__ButtonSection",
  componentId: "l6cvow-0"
})(["display:flex;justify-content:flex-end;& a{margin-left:6px;}"]);
const SectionLabel = styled(Typography).withConfig({
  displayName: "Page__SectionLabel",
  componentId: "l6cvow-1"
})(["margin-top:12px;"]);
const getTagUpdates = (tags, documentTags) => tags.filter(tag => documentTags.find(({
  text: docTagText
}) => docTagText === tag));
export default (({
  onAfter = () => {}
}) => {
  const dispatch = useDispatch();
  const {
    loading,
    value: documentItem
  } = useSelector(selectDocument);
  const documentTags = pathOr([], ['tags'], documentItem);
  const [title, setTitle] = React.useState(pathOr('', ['title'], documentItem));
  const [description, setDescription] = React.useState(pathOr('', ['description'], documentItem));
  const [tags, setTags] = React.useState(documentTags.map(({
    text
  }) => text));
  const handleUpdate = () => {
    if (documentItem === null || documentItem === void 0 ? void 0 : documentItem.oid) {
      const tagUpdates = getTagUpdates(tags, documentTags);
      dispatch(actions.updateDocument(documentItem.oid, {
        title,
        description
      }, tagUpdates));
      onAfter();
    }
  };
  return React.createElement(LoadingWrapper, {
    isLoading: loading
  }, React.createElement(Molecules.Dumb.Header, null, React.createElement(Trans, {
    id: "Project details"
  })), React.createElement(Atoms.Dumb.Section, null, React.createElement(Input, {
    label: i18n._("Title"),
    error: "oops this is bad",
    placeholder: i18n._("A catchy title can help you hook your audience."),
    onChange: e => setTitle(e.target.value)
  }), React.createElement(Textarea, {
    label: i18n._("Description"),
    placeholder: i18n._("Writing descriptions with keywords can help viewers find your projects more easily through search. You can give an overview of your project and place keywords in the beginning of the description."),
    onChange: e => setDescription(e.target.value)
  }), React.createElement(SectionLabel, {
    type: "label"
  }, React.createElement(Trans, {
    id: "Tags"
  })), React.createElement(TagsEditor, {
    list: tags,
    setList: setTags
  })), React.createElement(ButtonSection, null, React.createElement(Button, {
    theme: "white",
    onClick: onAfter
  }, React.createElement(Trans, {
    id: "SKIP"
  })), React.createElement(Button, {
    theme: "blue",
    onClick: handleUpdate
  }, React.createElement(Trans, {
    id: "Done"
  }))));
});